export const setCompanyIdFromQuery = {
  beforeCreate() {
    if (this.$route.query && this.$route.query.companyId) {
      const companyId = +this.$route.query.companyId;
      if (!Number.isNaN(companyId)) {
        this.$store.dispatch("company/setCompanyById", companyId);
      }
    }
  }
};
